// Créer un devis Zoho à partir du panier client - UTILISE SALES ORDERS INVENTORY
export async function createQuotationZoho(customerId, cart, user) {
  // cart : [{ product, quantity }]
  if (!customerId || !Array.isArray(cart) || cart.length === 0) {
    throw new Error('Client ou panier manquant');
  }
  
  // Adapter le format des lignes pour Zoho Inventory Sales Orders
  const line_items = cart.map(item => ({
    item_id: item.product.item_id || item.product.id,
    quantity: item.quantity,
    rate: item.product.price || 0 // prix unitaire
  }));
  
  try {
    // Utiliser les Sales Orders Zoho Inventory en mode DRAFT au lieu de Books Estimates
    const salesOrderData = {
      customer_id: customerId, // ID du contact Zoho
      line_items, 
      notes: `Quotation (Draft Sales Order) requested by ${user.name || user.email}`,
      date: new Date().toISOString().split('T')[0],
      status: 'draft', // DRAFT = Devis/Quotation
      reference_number: `QUOTE-${Date.now()}`
    };
    const apiBase = process.env.REACT_APP_LOCAL_API || '/api';
    const response = await fetch(`${apiBase}/zoho-inventory/sales-orders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(salesOrderData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('❌ Zoho Inventory Sales Orders API Error:', errorData);
      throw new Error(errorData.details || errorData.error || 'Erreur lors de la création de la Sales Order');
    }

    const result = await response.json();// Transformer la réponse pour le modal
    return {
      success: true,
      quotationNumber: result.salesorder_number || result.salesorder_id || 'NEW-SO',
      estimateId: result.salesorder_id,
      estimate: result.data
    };
  } catch (error) {
    console.error('❌ Erreur création Sales Order Zoho:', error);
    return {
      success: false,
      error: error.message || 'Erreur lors de la création de la Sales Order'
    };
  }
}

/**
 * Send quotation email notification
 */
export async function sendQuotationNotification(quotationData, customerInfo, orderLines) {
  try {
    const { sendDirectEmail } = await import('./portalUserService');

    const emailSubject = `New Quotation Request - ${quotationData.quotationNumber}`;
    
    const itemsList = orderLines.map(line => 
      `• ${line.product.name} - Quantity: ${line.quantity}`
    ).join('\n');

    const emailTemplate = `Hello ${customerInfo.name || customerInfo.email},

Thank you for your order request! We have received your quotation request and created quotation ${quotationData.quotationNumber}.

📋 Order Summary:
${itemsList}

🔍 Next Steps:
1. Our team will review your request
2. We will prepare a detailed quotation with pricing and availability
3. You will receive the official quotation within 24-48 hours
4. We will contact you to discuss any questions or modifications

📧 Quotation Reference: ${quotationData.quotationNumber}
📅 Request Date: ${new Date().toLocaleDateString()}

If you have any questions or need to modify your request, please contact us immediately.

Best regards,
The 1080 RC Team
Email: 1080rcm@gmail.com`;

    const result = await sendDirectEmail(
      customerInfo.email,
      emailSubject,
      emailTemplate
    );

    return result;
  } catch (error) {
    console.error('❌ Error sending quotation notification:', error);
    return {
      success: false,
      message: `Failed to send notification: ${error.message}`
    };
  }
}
